//
import axios, { type AxiosResponse } from 'axios';
import { CapacitorFacade } from '@/plugins/capacitorPlugin';
import type { IDocumentMetadata } from './models.content';

export default {
  /**
   * The function `streamDocument` asynchronously retrieves a document based on the provided metadata,
   * handling different endpoints for web and non-web environments.
   * @param documentMetadata - The `streamDocument` function is an asynchronous function that takes in
   * a `documentMetadata` object as a parameter. The `documentMetadata` object likely contains
   * information about a document such as its object code, type, and other relevant details needed to
   * retrieve the document.
   * @returns The `streamDocument` function returns the data received from the POST request made using
   * Axios.
   */
  async streamDocument(documentMetadata: IDocumentMetadata) {
    const isWeb = CapacitorFacade.isWeb();
    let response: AxiosResponse;

    if (isWeb) {
      response = await axios.post(
        `${window.appConfig.endpoints.cm}/content${
          documentMetadata.objectCode ? '/documents' : '/policy/documents/all'
        }`,
        documentMetadata,
        {
          headers: {
            accept: 'application/pdf',
          },
          responseType: 'arraybuffer',
          responseEncoding: 'binary',
        }
      );
    } else {
      response = await axios.post(
        `${window.appConfig.endpoints.bff}/document-links`,
        documentMetadata
      );
    }
    return response.data;
  },
};

export async function getTermsOfUseContent(url: string): Promise<string> {
  const client = axios.create();
  const res = await client.get(url);
  return res.data;
}
